import { TFunction } from 'i18next';
import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Tab } from 'ud-ui/components/tabs/interfaces';

/**
 * Подписи и порядок вкладок формы редактирования соревнования.
 *
 * Функция, а не константа: `t` доступна только во время рендера, и подписи,
 * посчитанные на импорте модуля, не пережили бы смену языка. Hash-и — в
 * `domain/enums/championship-edit-tab.ts`, они часть роута.
 */
export const getChampionshipEditTabs = (t: TFunction): Tab[] => [
  { hash: ChampionshipEditTab.COMMON, label: t('championship.editTabs.common') },
  { hash: ChampionshipEditTab.RULES, label: t('championship.editTabs.rules') },
  { hash: ChampionshipEditTab.TEAMS, label: t('championship.editTabs.applications') },
  { hash: ChampionshipEditTab.STEPS, label: t('championship.editTabs.steps') },
  { hash: ChampionshipEditTab.SYMBOLIC_TEAMS, label: t('championship.editTabs.symbolicTeams') },
  // Вкладки GAMES, APPLICATIONS и RESULTS были закомментированы до этой задачи.
];
